// 获得人员数据
// keyword:关键字
export const GetPersonThunk = async (keyword) => {
  try {
    if (keyword == "") return;
    return await fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/myAppService/findEmployees/v2?keyword=${encodeURIComponent(keyword)}&a=${new Date().getTime()}`, { method: "GET" });
  } catch (error) {
    return null;
  }
};

/**
添加人员
appId：应用id
body：
  | accounts |  是 |  array | 人员ids |
  | memberType |  是 |  int | 责任人类型0，应用责任人。1协同开发者 |
**/
export const PutPersonThunk = async (appId, body,type) => {
  try {
    const fetchUrlPath = {
      innerapp: 'service/apps/manage/appowner',
      isv: 'service/isv/apps/manage/appowner'
    };
    return await fetch(
      `/${process.env.REACT_APP_API_CONTEXT}/${fetchUrlPath[type]}/${appId}`,
      { method: "POST", body: JSON.stringify(body) }
    );
  } catch (error) {
    return null;
  }
};

/**
删除人员
@augment appId：应用id
@argument body：
  | accounts |  是 |  array | 人员ids |
  | memberType |  是 |  int | 责任人类型0，应用责任人。1协同开发者 |
**/
export const DeletePersonThunk = async (appId, body,type) => {
  try {
    const fetchUrlPath = {
      innerapp: 'service/apps/manage/appowner',
      isv: 'service/isv/apps/manage/appowner'
    };
    return await fetch(
      `/${process.env.REACT_APP_API_CONTEXT}/${fetchUrlPath[type]}/${appId}?a=${new Date().getTime()}`,
      { method: "DELETE", body: JSON.stringify(body) }
    );
  } catch (error) {
    return null;
  }
};

//  删除  灰度选择人员
export const DeletGrayPerson = async (appId, params) => {
  const result = await fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/myAppVersionService/gray/delApplimits/${appId}/v1`, {
    method: "POST",
    body: JSON.stringify(params)
  })
  return result;
}

//  新增 灰度人员
export const addGrayPerson = async (appId, params) => {
  const result = await fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/myAppVersionService/gray/addApplimits/${appId}/v1`, {
    method: "POST",
    body: JSON.stringify(params)
  })
  return result;
}
